export const pmsStatus = {
  PENDING: 'Pending',
  AT_WORK: 'In operation',
  PAUSED: 'Paused',
  TERMINATED: 'Terminated',
};

export const pmsStatusEnum = {
  PENDING: 'PENDING',
  AT_WORK: 'AT_WORK',
  PAUSED: 'PAUSED',
  TERMINATED: 'TERMINATED',
};

export const URL_REGEXP =
  /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/;

export const pmsDetailTabs = {
  BASIC_INFO: 'Basic info',
  CONTACT: 'contact',
  INTEGRATED_LANDLORD_LIST: 'Integrated landlord list',
};
